const PROMOTION = "/promotion";

export const GET_MECHANIC_BANNERS = `${PROMOTION}/getAllMechanicPromotionsForMechanicApp`;
